import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchUpdateOrganizationChartItemUserIds } from '../services/patchUpdateOrganizationChartItemUserIds.service';

export const updateOrganizationChartItemUserIds = createAsyncThunk(
  'organizationCharts/updateOrganizationChartItemUserIds',
  async ({ organizationChartItemId, userIds }, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await patchUpdateOrganizationChartItemUserIds({
      projectId: selectedProjectId,
      organizationChartItemId,
      userIds,
    });

    return response;
  }
);
